<template>
  <div class="condensed-mobile-rail grid-x align-middle align-justify nowrap" :class="paddings">
    <div class="grid-x align-middle nowrap grow-2">
      <MenuButton class="mr-12 no-shrink" />
      <Logo />
      <Search
        v-if="!isProminentSearchBar"
        class="margin-left-xs"
        :class="{
          'search-condensed': !isSearchModalActive,
          'search-condensed-open': isSearchModalActive,
        }"
      />
    </div>
    <div class="grid-x align-middle nowrap no-shrink">
      <ProfileStatus v-if="isDomestic && isProminentSearchBar" />
      <div v-if="isAiScriptEnabled && isDomestic" class="grid-x relative margin-left-xs no-shrink">
        <AskAI />
      </div>
      <BagIcon class="bag-icon-large margin-left-xs" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import MenuButton from './MenuButton.common';
import ProfileStatus from './ProfileStatus';
import Logo from '../common/Logo.common';
import BagIcon from '../common/BagIcon.common';
import AskAI from '../link-rail/AskAI.common';
import useAskAiVisibility from '~/composables/useAskAiVisibility';
import Search from '~/components/search/Search.common';
import { GET_ATTRS } from '#shared/types/getters';

const pageData = usePageData();
const navHeader = useNavHeader();
const { isAiScriptEnabled } = useAskAiVisibility();
const isDomestic = computed(() => pageData.navigation.context.isDomestic);
const isSearchModalActive = computed(() => navHeader.isSearchModalActive);
const isProminentSearchBar = computed(() => !!navHeader[GET_ATTRS].isProminentSearchBar);
const paddings = computed(() => {
  return isProminentSearchBar.value ? ['pt-14', 'pb-14'] : ['pt-8', 'pb-8'];
});
</script>

<style lang="scss" brand="mcom">
.search-condensed {
  width: 100%;
}

.pt-8 {
  padding-top: 8px;
}

.pb-8 {
  padding-bottom: 8px;
}

.pt-14 {
  padding-top: 14px;
}

.pb-14 {
  padding-bottom: 14px;
}

.mr-12 {
  margin-right: 12px;
}

.no-shrink {
  flex-shrink: 0;
}

.grow-2 {
  flex-grow: 2;
}
</style>
